export default __webpack_public_path__ + "static/media/Foto-397-300x200.e9bccece.png";